/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import MainBody from "../../components/MainBody/MainBody";
import BootstrapTable from "react-bootstrap-table-next";
import sortCaret from "../../components/SortCaret";
import { formatNumber } from "../../lib/Misc";
import { useTrust } from "../../lib/context/TrustContext";

const RefundReceiptHistory = ({ receiptId }) => {
  const [receiptList, setReceiptsList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const { trustId } = useTrust();

  const fetchRefundHistory = useCallback(
    async (passLimit, passPage) => {
      if (trustId) {
        try {
          setLoading(true);
          const { data } = await get(
            `${API.GET_RECEIPT_REFUND_HISTORY}?sort_column=${sortField ? sortField : ""}&sort_order=${
              sortOrder ? sortOrder : ""
            }&trust_id=${trustId ? trustId : ""}${
              receiptId ? `&receipt_id=${receiptId}` : ""
            }`,
          );

          setLoading(false);
          const receiptList = data.data;
          setReceiptsList(receiptList);
          return data.data;
        } catch (error) {
          setLoading(false);
          setReceiptsList([]);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sortField, sortOrder, trustId],
  );

  const receiptsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      let originalAmount = (i == 0
        ? Number(receiptList[i]?.original_amount)
        : Number(items[i - 1]?.original_remaining_balance));

      items.push({
        key: receiptList[i]?.id,
        order: receiptList[i]?.receipt_order
          ? receiptList[i]?.receipt_order
          : "-",
        receipt_number: receiptList[i]?.receipt_number
          ? receiptList[i]?.receipt_number
          : "-",
        refund_date: receiptList[i]?.refund_date
          ? receiptList[i]?.refund_date
          : "-",
        amount: originalAmount ? (
          <b>${formatNumber(Number(originalAmount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        refund_amount: receiptList[i]?.used_amount ? (
          <b>${formatNumber(Number(receiptList[i]?.used_amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        remaining_balance:
          originalAmount && receiptList[i]?.used_amount ? (
            <b>
              $
              {formatNumber(
                Number(originalAmount) - Number(receiptList[i]?.used_amount),
              )}
            </b>
          ) : (
            <b>{"$0.00"}</b>
          ),
        original_remaining_balance:
          originalAmount && receiptList[i]?.used_amount
            ? Number(originalAmount) - Number(receiptList[i]?.used_amount)
            : 0,
      });
    }
    return items;
  };

  const receipts = receiptsGenerator(receiptList?.length);

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "refund_date",
      text: "Refund Date",
      sort: true,
      sortCaret,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "order",
      text: "Order",
      sort: true,
      sortCaret,
    },
    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   dataField: "receipt_number",
    //   text: "Receipt Number",
    //   sort: true,
    //   sortCaret,
    // },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "amount",
      text: "Amount (Inc)",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "refund_amount",
      text: "Refund Amount",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "remaining_balance",
      text: "Remaining Balance",
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  useEffect(() => {
    fetchRefundHistory();
  }, [fetchRefundHistory]);

  return (
    <>
      <MainBody
        search={false}
        actionContent={<></>}
        loading={loading}
        mainClassName="w-[calc(100%-3rem)]"
        expandList={true}
      >
        <div className="custom-table">
          <div className="table-body-class">
            <BootstrapTable
              keyField="key"
              remote
              data={receipts}
              columns={columns}
              onTableChange={handleTableChange}
              rowClasses={(row) => {
                if (row?.is_reversed) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.is_refund) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.is_disposed) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.archived) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                return TRClasses;
              }}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>
        </div>
      </MainBody>
    </>
  );
};

export default RefundReceiptHistory;
